import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "bb_token";
const USER_KEY = "bb_user";

export const auth = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  getUser: () => {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  },
  save: (token, user) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
};

export const apiClient = axios.create({ baseURL: API });

apiClient.interceptors.request.use((config) => {
  const token = auth.getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiClient.interceptors.response.use(
  (resp) => resp,
  (err) => {
    if (err?.response?.status === 401) {
      auth.clear();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const apiLogin = (username, password) =>
  apiClient.post("/auth/login", { username, password }).then((r) => r.data);

export const apiListOrders = () => apiClient.get("/orders").then((r) => r.data);
export const apiCreateOrder = (payload) =>
  apiClient.post("/orders", payload).then((r) => r.data);
export const apiUpdateOrder = (id, payload) =>
  apiClient.put(`/orders/${id}`, payload).then((r) => r.data);
export const apiDeleteOrder = (id) =>
  apiClient.delete(`/orders/${id}`).then((r) => r.data);
export const apiTotals = (date) =>
  apiClient
    .get(`/totals${date ? `?date=${date}` : ""}`)
    .then((r) => r.data);
